import { Directive, Pipe } from '@angular/core';

@Pipe({
  name: 'hubColumn',
  standalone: false
})

export class HubColumnCheckPipe {
  transform(element, infoId) {
      return (element?.find(el => +el?.additionalFrontUserInfoId === +infoId)?.info === 'true');
  }
}
